<template>
  <div>
    <Header
      :title="'各種設定'"
      data-test="header"
    />
    <div
      class="boss-admin-container clearfix"
    >
      <sidebar />
      <router-view />
    </div>
  </div>
</template>

<script>
import Header from '@/components/templates/Header'
import Sidebar from '@/components/organisms/Sidebar'
import { mapActions } from 'vuex'

export default {
  components: {
    Sidebar,
    Header
  },
  created () {
    this.storeMaster('specialFavors')
    this.storeMaster('optionalPermissions')
    this.storeMaster('receivableMailTypes')
    this.storeMaster('autoReplyMailSchedules')
  },
  methods: {
    ...mapActions([
      'storeMaster'
    ])
  }
}
</script>
